import React, { useState, useRef, Fragment, useEffect } from "react";
import { history } from "../../helpers/history";
import validator from "validator";
import DateFormat from "../../helpers/DateFormat";
import crossImgs from "../../assets/images/icons/cross.svg";
import RefreshToken from "../../helpers/RefreshToken";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import emptyclient from "../../assets/images/icons/clients-empty.svg";
import transactionService from "../../services/transaction.service";
import { useSelector } from "react-redux";
import moment from "moment";
import ModelPopup from "../../helpers/ModelPopup";
import CurrencyFormat from 'react-currency-format';
import HideTransaction from "../../helpers/HideTransactions";
const headersdatadynamics = [
  "TRANSACTION TYPE",
  "MERCHANT NAME",
  "STATUS",
  "AMOUNT",
  "DATE",
]
const SearchGridInputData = [
  {
    Name: "",
    UserId: "",
    StartDate: "",
    EndDate: "",
    PageNumber: 0,
    PageSize:100,
    // Size:10,
    scrolled: false,
    isFirstTime: true,
  },
];
var fontStyle = {
  textTransform: "uppercase",
};
var centreAlign = {
  textAlign: "center"
}

const SearchGridCardTransactions = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [name, setCompanyName] = useState("");
  const [StartDate, setDateFrom] = useState("");
  const [EndDate, setDateTo] = useState("");
  const searchTbl = useRef();
  const [loadingData, setLoadingData] = useState(false);
  const [searchData, setSearchData] = useState();
  const [searchGridSuccess, setSearchGridSuccess] = useState(false);
  const [SearchInputDisabled, setSearchDisabled] = useState(false);
  const { user: currentUser } = useSelector((state) => state.auth);
  const [UserId, setUserId] = useState(props.UserId);
  const [totalCount, setTotalCount] = useState(0);
  const [hasMoreData, setHasMoreData] = useState(true);
  //Transaction Models Showing Values
  const [TransactionsType, setTransactionsType] = useState("");
  const [Status, setStatus] = useState("");
  const [CurrencyCode, setCurrencyCode] = useState("");
  const [Amount, setAmount] = useState("");
  const [Date, setDate] = useState("");
  const [ReferenceNumber, setReferenceNumber] = useState("");
  const [MerchantName, setMerchantName] = useState("");
  const [ApprovalCode, setApprovalCode] = useState("");
  const [DeclineReason, setDeclineReason] = useState("");
  const [IssuerFeesOB, setIssuerFeesOB] = useState([]);
  const [FxFee, setFxFee] = useState("");
  //Model popup Transactions
  const [modalShowTransactions, setModalShowTransactions] = useState(false);
  const [Month, setMonth] = useState(0);
  const [Year, setYear] = useState(0);
  const styleObj = {
    fontSize: 10,
  }
  useEffect(() => {
    SearchClickHandler(null, true);
  }, []);
  const isIssuerAllowed = ["IssuerB", "IssuerM"].includes(currentUser?.user?.IssuerName) ||
                        ["IssuerB", "IssuerM"].includes(props?.IssuerCategory);
  const isIssuerOB = ["IssuerOB", "Issuer11", "Issuer12"].includes(currentUser?.user?.IssuerName) ||
                     ["IssuerOB", "Issuer11", "Issuer12"].includes(props?.IssuerCategory);
  const parseIssuerOBFees = (feeString) => {
    if (!feeString || feeString.trim() === "") {
      setIssuerFeesOB([]);
      return;
    }

    // Split by comma and parse each fee
    const feePairs = feeString.split(",").map(item => item.trim()).filter(item => item !== "");
    const parsedFees = [];

    feePairs.forEach(pair => {
      if (pair.includes(":")) {
        const [key, value] = pair.split(":").map(item => item.trim());
        // Format the label to be more readable
        const formattedKey = key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());
        parsedFees.push({ label: formattedKey, value: value });
      }
    });

    setIssuerFeesOB(parsedFees);
  };
  const handleInputSearchClick = (e) => {
    e.preventDefault();
    setModalShow(true);
    setSearchDisabled(true);
    setCompanyName("");
    dateToHandler("");
    dateFromHandler("");
  };
  const dateFromHandler = (e) => {
    SearchGridInputData[0].StartDate = e;
    if (e) {
      let date = SearchGridInputData[0].StartDate;
      if (SearchGridInputData[0].StartDate !== "") {
        SearchGridInputData[0].StartDate = moment(SearchGridInputData[0].StartDate).format("YYYY-MM-DD");
        setDateFrom(date);
      } else {
        setDateFrom(date);
      }
    }
  };
  const dateToHandler = (e) => {
    SearchGridInputData[0].EndDate = e;
    if (e) {
      let date = SearchGridInputData[0].EndDate;
      if (SearchGridInputData[0].EndDate !== "") {
        SearchGridInputData[0].EndDate = moment(SearchGridInputData[0].EndDate).format("YYYY-MM-DD");
        setDateTo(date);
      } else {
        setDateTo(date);
      }
    }
  };
  const onChangeMonth = (e) => {
    const name = e.target.selectedOptions[0].value;
    setMonth(parseInt(name));
  }

  const onChangeYear = (e) => {
    const name = e.target.selectedOptions[0].value;
    setYear(parseInt(name));
  }
  const sortDateTransaction = (obj) => {
    let reArr = obj;
    reArr.sort((a, b) => {
      const dateA = new Date(a.dateOfTransaction);
      const dateB = new Date(b.dateOfTransaction);

      if (dateA < dateB) {
        return 1;
      } else if (dateA > dateB) {
        return -1;
      } else {
        return 0;
      }
    })
    setSearchData(reArr);
  }
  const SearchClickHandler = (e, isFromUseEffect) => {
    setLoadingData(true);
    if (!SearchGridInputData[0].scrolled) {
      setSearchGridSuccess(false);
    }
    if (isFromUseEffect) {
      SearchGridInputData[0].PageNumber = 1;
      setSearchData("");
      if (props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12") {
        setHasMoreData(true);
      }
    }
    setModalShow(false);
    setSearchDisabled(false);
    transactionService
      .searhGridTransactionsCards(
        UserId,
        SearchGridInputData[0].StartDate,
        SearchGridInputData[0].EndDate,
        SearchGridInputData[0].PageNumber,
        SearchGridInputData[0].PageSize,
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp.data && resp.data.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
            setTotalCount(resp.data.payload.result.item1.totalElements);
            // For IssuerOB, check if there's more data based on totalElements
            if (props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12") {
              const totalElements = resp.data.payload.result.item1.totalElements;
              setHasMoreData(totalElements > 0);
            }
          }
          if (
            resp.data.payload.result.item1.content.length > 0 ||
            searchData.length > 0
          ) {
            setTotalCount(resp.data.payload.result.item1.totalElements);
            // For IssuerOB, check if there's more data based on totalElements
            if (props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12") {
              const totalElements = resp.data.payload.result.item1.totalElements;
              setHasMoreData(totalElements > 0);
            }
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(
                resp.data.payload.result.item1.content
              );
              // For IssuerOB, sort the combined data by date (latest first)
              if (props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12") {
                sortDateTransaction(appendedData);
                // Update dataset with all accumulated transactions for Excel export
                props?.setDataset(appendedData);
              } else {
                setSearchData(appendedData);
              }
            } else {

              let reversearray = resp.data.payload.result.item1.content;
              let filtereddata = reversearray.reverse()
              if (props?.issuerCategory === "IssuerG"||props?.issuerCategory=="IssuerTG"||props?.issuerCategory=="IssuerTGV"
                |props?.issuerCategory=="IssuerZ" || props?.issuerCategory=="IssuerX" ||props?.issuerCategory=="IssuerE"
                ||props?.issuerCategory=="IssuerER" || props?.issuerCategory=="IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12"
              )
                sortDateTransaction(filtereddata);
              else
                setSearchData(filtereddata);
              SearchGridInputData[0].PageNumber = 1;
              props?.setDataset(reversearray);
            }
            setSearchGridSuccess(true);
            SearchGridInputData[0].scrolled = false;
            if (SearchGridInputData[0].isFirstTime && (isIssuerOB)) {
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
            }
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
  };
  const tblScrollHandler = (e) => {
    if (props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12") {
      // For IssuerOB/Issuer11/Issuer12, use hasMoreData flag
      if (
        !SearchGridInputData[0].scrolled &&
        hasMoreData
      ) {
        SearchGridInputData[0].scrolled = true;
        SearchGridInputData[0].PageNumber =
          SearchGridInputData[0].PageNumber + 1;
        SearchClickHandler();
      }
      return;
    }
    if (
      !SearchGridInputData[0].scrolled &&
      SearchGridInputData[0].PageNumber + 1 <= totalCount - 1
    ) {
      SearchGridInputData[0].scrolled = true;
      SearchGridInputData[0].PageNumber =
        SearchGridInputData[0].PageNumber + 1;
      SearchClickHandler();
    }
  };
  const filterTransactions = (transactions) => {
    // Define the criteria for removal
    const excludedMerchantNames = ["Authorization Fee", "FX Fee", "POS Fee"];
    const clientIdToExclude = [102, 108];

    // Check if ClientId is in the exclusion list
    if (clientIdToExclude.includes(props?.clientId)) {
      return transactions.filter(
        (transaction) =>
          !excludedMerchantNames.includes(transaction.merchantName)
      );
    }

    // If ClientId is not excluded, return the original transactions
    return transactions;
  };
  const renderTableHeader = () => {
    if ([61, 62, 105].includes(currentUser?.user?.ClientId)) {
      let header = Object.values(headersdatadynamics);
      return header.map((key, index) => {

        return <th key={index}>{key.toUpperCase()}</th>;
      });
    }
    else {
      let header = Object.values(props.headersdata);

      return header.map((key, index) => {

        return <th key={index}>{key.toUpperCase()}</th>;
      });
    }
  };
  const GetCardTransactionsspecificmonth = (e, isFromUseEffect) => {
    setLoadingData(true);
    if (!SearchGridInputData[0].scrolled) {
      setSearchGridSuccess(false);
    }
    if (isFromUseEffect) {
      SearchGridInputData[0].PageNumber = 0;
      setSearchData("");
    }
    setModalShow(false);
    setSearchDisabled(false);
    transactionService
      .GetCardTransactionsspecificmonth(
        UserId,
        Month,
        Year
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp.data && resp.data.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
            setTotalCount(resp.data.payload.result.item1.totalElements);
          }
          if (
            resp.data.payload.result.item1.content.length > 0 ||
            searchData.length > 0
          ) {
            setTotalCount(resp.data.payload.result.item1.totalElements);
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(
                resp.data.payload.result.item1.content
              );
              setSearchData(appendedData);
            } else {
              let reversearray = resp.data.payload.result.item1.content;
              let filtereddata = reversearray.reverse();
              let filteredData = filterTransactions(filtereddata);
              if (props?.issuerCategory === "IssuerG"||props?.issuerCategory === "IssuerTG"||props?.issuerCategory === "IssuerTGV"||
                props?.issuerCategory === "IssuerZ" || props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12"
              ){
                sortDateTransaction(filteredData);
              }

              else{
                setSearchData(filteredData);
              }
                
              SearchGridInputData[0].PageNumber = 0;

              if ([102, 108].includes(currentUser?.user?.ClientId)) {
                const feesToRemove = ["AUTHORIZATION FEE", "ATM FEE", "FX FEE", "POS FEE"];
                let filteredArray = filteredData.filter(item => !feesToRemove.includes(item.merchantName?.toUpperCase()));
                props?.setDataset(filteredArray);
              } else {
                props?.setDataset(reversearray);
              }

            }
            setSearchGridSuccess(true);

            SearchGridInputData[0].scrolled = false;
            // if (SearchGridInputData[0].isFirstTime) {
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
            // }
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);
        setTotalCount(0);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            GetCardTransactionsspecificmonth();
          }
        })();
      });
  };
  const showTransactionsPopup = (
    transactionType,
    merchantName,
    status,
    authAmount,
    authCurrencyCode,
    dateOfTransaction,
    retrievalReferenceNumber,
    transactionResponse,approvalCode,localDescription,transactionMode
  ) => {
    setModalShowTransactions(true);
    setTransactionsType(transactionType);
    setStatus(status);
    setCurrencyCode(authCurrencyCode);
    let amount = calculateB4BFee(transactionResponse, authAmount);
    setAmount(amount);
    setDate(dateOfTransaction);
    setReferenceNumber(retrievalReferenceNumber);
    setMerchantName(merchantName);
    setApprovalCode(approvalCode);
    if (props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12") {
      let IssuerOBBFees = localDescription ?? "";
      setFxFee(IssuerOBBFees);
      parseIssuerOBFees(transactionMode ?? ""); // Parse the transactionMode fees into multiple lines
      setDeclineReason(approvalCode ?? "");
    }
  };
  const removeTransactionsBilly = (transaction) => {
    const check = HideTransaction?.includes(transaction)
    return check;

  }
  const sanitizeDate = (dateStr) => {
    return dateStr?.startsWith("0001-01-01") ? true : false;
  };
  const renderTableData = () => {
    return searchData.map((data, index) => {
      const {
        transactionType,
        merchantName,
        status,
        authCurrencyCode,
        authAmount,
        dateOfTransaction,
        retrievalReferenceNumber,
        transactionUuid, transactionResponse,approvalCode,localDescription,transactionMode
      } = data; //destructuring
      if (transactionType?.toUpperCase() === "AUTHORIZATION_ADVICE" || transactionType?.toUpperCase() === "PIN_QUERY" || transactionType?.toUpperCase() === "PIN_CHANGE")
        return

      if (removeTransactionsBilly(transactionUuid) === true) {
        return
      }
      if ([102, 108].includes(currentUser?.user?.ClientId) && ["AUTHORIZATION FEE", "ATM FEE", "FX FEE", "POS FEE"].includes(merchantName?.toUpperCase()))
        return;

      return (
        <tr key={retrievalReferenceNumber}>
          {[61, 62, 105].includes(currentUser?.user?.ClientId) &&
            <td style={fontStyle} title={transactionType} >{transactionType?.substr(0, 20)}{transactionType?.length > 20 && ("...")}</td>}

          <td style={fontStyle} title={merchantName} >{merchantName?.substr(0, 10) ?? "-"}{merchantName?.length > 10 && ("...")}</td>
          <td style={fontStyle}>{transactionType=="refund"? transactionType:status}</td>
            {
              authAmount < 0 ? (<td><CurrencyFormat value={authAmount} displayType={'text'} thousandSeparator={true} allowNegative={false} prefix="(" suffix=")" /></td>) : (
                <td style={fontStyle}><CurrencyFormat value={authAmount} displayType={'text'} thousandSeparator={true} /> {authCurrencyCode}</td>
              )
            }
          {
    sanitizeDate(dateOfTransaction) ?(
      <td style={fontStyle}>
          
          </td>
    ):(
      <td style={fontStyle}>
          <DateFormat date={dateOfTransaction} />
          </td>
    )
}
          {![61, 62, 105].includes(currentUser?.user?.ClientId) &&
            <td>
              <span
                className="icon-show"
                onClick={() =>
                  showTransactionsPopup(
                    transactionType,
                    merchantName,
                    status,
                    authAmount,
                    authCurrencyCode,
                    dateOfTransaction,
                    retrievalReferenceNumber,
                    transactionResponse,
                    approvalCode,
                    localDescription,
                    transactionMode
                  )
                }
              ></span>
            </td>}
        </tr>
      );
    });
  };
  const HideSearchPopupDiv = () => {
    setModalShow(false);
    setSearchDisabled(false);
    setCompanyName("");
  };
  const ClearSearchData = () => {
    if (currentUser?.user?.IssuerName === "IssuerG" || props?.IssuerCategory=="IssuerG") {
      setDateFrom("");
      setDateTo("");
      if (document.getElementById("MonthIssuerG") !== null)
        document.getElementById("MonthIssuerG").value = 0;
      if (document.getElementById("YearIssuerG") !== null)
        document.getElementById("YearIssuerG").value = 0;
      setMonth(0);
      setYear(0);
      SearchClickHandler();
    }
    else {
      setCompanyName("");
      dateToHandler("");
      dateFromHandler("");
      ClearInputData();
    }

  };
  const ClearInputData = () => {
    if (document.getElementById("clientNameDD") !== null)
      document.getElementById("clientNameDD").value = "";
    setTimeout(() => {
      [...document.getElementsByClassName("r-input-group")].forEach(
        (element) => {
          element.children[0].value = "";
        }
      );
      document.getElementById("searchBtnClients").click();
    }, 500);
  };

  const renderTransactionDetails = () => {
    return (

      <div class="row">
        <div class="col-md-12">
          <h3>Transaction Details</h3>
          <div class="mt-16">
            <form onSubmit={(e) => e.preventDefault()}>
              <ul class="ul-card-details-popup">
                <li class="d-flex justify-content-between mb-3">
                  <label>Merchant Name</label>
                  <span>{MerchantName ? MerchantName : '-'}</span>
                </li>
                <li class="d-flex justify-content-between mb-3">
                  <label>Status</label>
                  <span>{Status}</span>
                </li>
                <li class="d-flex justify-content-between mb-3">
                  <label>Amount</label>
                  <CurrencyFormat
                    value={Math.abs(Amount)}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={Amount < 0 ? '(' : ''}
                    suffix={Amount < 0 ? ')' : ''}
                    allowNegative={Amount < 0}
                  />
                </li>
                <li class="d-flex justify-content-between mb-3">
                  <label>Date</label>
                  <span><DateFormat date={Date} /></span>
                </li>
                {
                  isIssuerAllowed &&(
                    <li class="d-flex justify-content-between  mb-3">
                  <label>ApprovalCode/Decline Name</label>
                  <span>{ApprovalCode}</span>
                   </li>
                  )
                }
                {
                  props?.issuerCategory === "IssuerOB" || props?.issuerCategory === "Issuer11"||props?.issuerCategory === "Issuer12" && (
                    <>
                      {IssuerFeesOB && IssuerFeesOB.length > 0 ? (
                        IssuerFeesOB.map((fee, index) => (
                          <li key={index} class="d-flex justify-content-between mb-3">
                            <label>{fee.label}</label>
                            <span>{fee.value}</span>
                          </li>
                        ))
                      ) : null}
                      <li class="d-flex justify-content-between mb-3">
                        <label>FX Fee</label>
                        <span><CurrencyFormat value={FxFee} displayType={'text'} thousandSeparator={true} /></span>
                      </li>
                      <li class="d-flex justify-content-between mb-3">
                        <label>Decline Reason</label>
                        <span>{DeclineReason}</span>
                      </li>
                    </>
                  )
                }
                <li class="d-flex justify-content-between">
                  <label>Ref #</label>
                  <span>{ReferenceNumber}</span>
                </li>
              </ul>

            </form>
          </div>
        </div>
      </div>

    );
  };
  const calculateB4BFee = (transactionResponse, authAmount) => {
      return authAmount
  }
  return (
    <Fragment>
      <div className="row align-items-center mt-14">
        {/* <div className="col-6">
          <h3> Overall Transactions</h3>
        </div>
        */}
      </div>
      <div className="mt-0 mt-sm-4">
        <div className="tab-content" id="myTabContent2">
          <div
            className="tab-pane fade show active"
            id="allClients"
            role="tabpanel"
            aria-labelledby="allClients-tab"
          >
            {/* no client found  */}
            <div className="d-flex align-content-center justify-content-center no-clients-msg d-none">
              <div className="text-center">
                <span className="icon-clients-empty">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                </span>
                <h3>Empty Clients Listing</h3>
                <h6>There is no Client(s) available for now.</h6>
              </div>
            </div>
            <Fragment>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="row row-search">
                  <div className="col-xl-12 col-12">
                    <div className="form-group">
                      <div className="form-controls">
                        <input
                          type="text"
                          className="form-control"
                          placeholder={props.placeholdervalue}
                          onClick={handleInputSearchClick}
                          disabled={SearchInputDisabled}
                        />
                        <span className="icon-search _ico"></span>
                        {/* search box  */}
                        <div
                          className="bo-cardsearch"
                          style={{ display: modalShow ? "" : "none" }}
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <img
                                className="cross-icon cross-modal"
                                src={crossImgs}
                                aria-label="Close"
                                onClick={HideSearchPopupDiv}
                                alt=""
                              />
                            </div>
                            {
                              (currentUser?.user?.IssuerName === "IssuerG"||props?.IssuerCategory=="IssuerG") ? (<div className="col-md-6">
                                <div className="form-group form-search mr-20">
                                  <label>Month</label>
                                  <div className="form-controls">
                                    <select
                                      onChange={onChangeMonth}
                                      className="form-control no-icon"
                                      id="MonthIssuerG"
                                    >
                                      <option select="selected" value={Month}>
                                        Select
                                      </option>
                                      <option value={1}>
                                        January
                                      </option>
                                      <option value={2}>
                                        February
                                      </option>
                                      <option value={3}>
                                        March
                                      </option>
                                      <option value={4}>
                                        April
                                      </option>
                                      <option value={5}>
                                        May
                                      </option>
                                      <option value={6}>
                                        June
                                      </option>
                                      <option value={7}>
                                        July
                                      </option>

                                      <option value={8}>
                                        August
                                      </option>
                                      <option value={9}>
                                        September
                                      </option>
                                      <option value={10}>
                                        October
                                      </option>
                                      <option value={11}>
                                        November
                                      </option>
                                      <option value={12}>
                                        December
                                      </option>

                                    </select>
                                  </div>
                                </div>
                              </div>) : (<div className="col-md-6">
                                <div className="form-group form-search mr-20">
                                  <label>Date From</label>
                                  <div className="form-controls">
                                    <ReactDatePickerHelper
                                      datevalue={StartDate}
                                      onchangedate={dateFromHandler}
                                    />
                                  </div>
                                </div>
                              </div>)
                            }
                            {(currentUser?.user?.IssuerName === "IssuerG"||props?.IssuerCategory=="IssuerG") ? (<div className="col-md-6">
                              <div className="form-group form-search mr-20">
                                <label>Year</label>
                                <div className="form-controls">
                                  <select
                                    onChange={onChangeYear}
                                    className="form-control no-icon"
                                    id="YearIssuerG"
                                  >
                                    <option select="selected" value={0}>
                                      Select
                                    </option>
                                    <option value={2022}>
                                      2022
                                    </option>
                                    <option select="selected" value={2023}>
                                      2023
                                    </option>
                                    <option select="selected" value={2024}>
                                      2024
                                    </option>
                                    <option select="selected" value={2025}>
                                      2025
                                    </option>
                                    <option select="selected" value={2026}>
                                      2026
                                    </option>
                                    <option select="selected" value={2027}>
                                      2027
                                    </option>
                                    <option select="selected" value={2028}>
                                      2028
                                    </option>
                                    <option select="selected" value={2029}>
                                      2029
                                    </option>
                                    <option select="selected" value={2030}>
                                      2030
                                    </option>

                                  </select>
                                </div>
                              </div>
                            </div>) : (<div className="col-md-6">
                              <div className="form-group form-search mr-20">
                                <label>Date To</label>
                                <div className="form-controls">
                                  <ReactDatePickerHelper
                                    datevalue={EndDate}
                                    onchangedate={dateToHandler}
                                  />
                                </div>
                              </div>
                            </div>
                            )}

                            <div className="col-md-12">
                              <div className="form-group submit-field form-search">
                                {(currentUser?.user?.IssuerName === "IssuerG" || props?.IssuerCategory=="IssuerG") ? (<button
                                  id="searchBtnClients"
                                  className="btn btn-large mr-19"
                                  onClick={GetCardTransactionsspecificmonth}
                                >
                                  Search
                                </button>) : (<button
                                  id="searchBtnClients"
                                  className="btn btn-large mr-19"
                                  onClick={SearchClickHandler}
                                >
                                  Search
                                </button>)}

                                <button
                                  className="btn btn-outline"
                                  onClick={ClearSearchData}
                                >
                                  Clear Search
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span className="help-block d-none"></span>
                    </div>
                  </div>
                </div>
              </form>
            </Fragment>
          </div>

          {searchGridSuccess && (
            <div className="table-wrap" ref={searchTbl}>
              <table
                className="table table-borderless bo-table table-cards"
                {...(props?.issuerCategory === "IssuerOB" && {
                  onScroll: tblScrollHandler,
                  onWheel: tblScrollHandler
                })}
              >
                <thead>
                  <tr>{renderTableHeader()}</tr>
                </thead>
                <tbody>{renderTableData()}</tbody>
              </table>
            </div>
          )}
          {loadingData ? (
            <div className="loading-more">
              <div className="loader">
                <div></div>
              </div>
              <p>loading data</p>
            </div>
         ) : (totalCount === 0 && (!searchData || searchData.length === 0)) ? (
            <div className="d-flex align-content-center justify-content-center no-clients-msg ">
              <div className="text-center">
                <span className="icon-transaction-empty">
                  <span className="path1"></span><span className="path2"></span>
                  <span className="path3"></span><span className="path4"></span>
                  <span className="path5"></span><span className="path6"></span>
                </span>
                <h3>Empty Transactions Listing</h3>
                <h6>There are no transactions available for now.</h6>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div>
        <ModelPopup
          key={1}
          show={modalShowTransactions}
          onHide={() => setModalShowTransactions(false)}
          modelheading={""}
          modelbody={renderTransactionDetails()}
          showheader={"false"}
          dialogClassName="modal-dialog modal-dialog-centered mwidth-52"
          className="smallPopup issueCardSmall"
          backdrop="static"
          keyboard={false}
        />
      </div>
    </Fragment>
  );

};

export default SearchGridCardTransactions;
